// Arma el valor CSS de "background": sólido, o difuminado (degradado hacia
// blanco) si difuminado es true/1. Reutilizable en cualquier color del sitio.
export const armarFondo = (color, difuminado) => {
  if (difuminado) {
    return `linear-gradient(180deg, ${color} 0%, #ffffff 100%)`;
  }
  return color;
};

// Calcula el fondo de página para un servicio, usando su propio color_fondo
// y fondo_difuminado.
export const getFondoServicio = (servicioActual, fallback = "#f0f4ff") => {
  const color = servicioActual?.color_fondo || fallback;
  return armarFondo(color, servicioActual?.fondo_difuminado);
};
